<template lang="pug">
    section.payment-step
        .alert.mt-0
            p {{ $t('Total amount') }}
            b {{ grandTotal | moneyFormat(currency) }}
        el-form-item.no-margin(v-if="form.paymentMethod" :label="$t('Payment Method')" prop="paymentMethod.name")
            el-input(v-model="form.paymentMethod.name")
</template>

<i18n>
{
    "de": {
        "Invoice": "Rechnung",
        "Total amount": "Gesamtbetrag",
        "Payment Method": "Zahlungsmethode"
    }
}
</i18n>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'PaymentStep',
    props: {
        form: {
            type: Object,
            required: true,
        },
        rules: {
            type: Object,
            required: true,
        },
        grandTotal: {
            type: Number,
            required: true
        },
    },
    computed: {
        customerGroup() {
            const customer = this.form.purchaser.customer
            return _.get(customer, 'customerGroup') || _.get(this.activeCms, 'shop.defaultCustomerGroup')
        },
        currency() {
            return _.get(this.customerGroup, 'currency.iso4217') || 'EUR'
        },
        ...mapGetters({
            activeCms: 'activeCms',
        }),
    },
    mounted() {
        if (!this.form.paymentMethod) {
            this.$set(this.form, 'paymentMethod', { name: this.$t('Invoice') })
        }
    },
};
</script>
